<script setup lang="ts">
import HomeHeader from "@/views/home/HomeHeader.vue";
import HomeFooter from "@/views/home/HomeFooter.vue";

</script>

<template>
  <div id="wrap" class="r2playground">

    <home-header />

    <main id="ct">
      <div class="container support login-wrap">

        <router-view></router-view>
      </div>
      <!-- //container -->
    </main>

    <home-footer />

  </div>
</template>

<style scoped>

</style>